var _mask, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgProSubscr = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 76,
  height: 76,
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  height: 76,
  width: 76,
  y: 0,
  x: 0,
  maskUnits: "userSpaceOnUse",
  id: "mask0"
}, /*#__PURE__*/React.createElement("rect", {
  id: "svg_1",
  fillOpacity: 0.5,
  fill: "#E4E8EC",
  rx: 6,
  height: 76,
  width: 76
}))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
  id: "svg_2",
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "svg_3",
  fill: "#91A3B5",
  rx: 6,
  height: 35.0112,
  width: 36.7191,
  y: 46.9663,
  x: -13.6629
}), /*#__PURE__*/React.createElement("rect", {
  id: "svg_4",
  fill: "#91A3B5",
  rx: 6,
  height: 35.0112,
  width: 36.7191,
  y: -8.53931,
  x: 49.5281
})))));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgProSubscr, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/proSubscr.3c5bfdc6.svg";
export { ForwardRef as ReactComponent };